import React, { useMemo } from 'react';
import classNames from 'classnames';
import type { InputProps as AntdInputProps } from 'antd/lib/input';
import { Input as AntdInput } from 'antd';
import { Icon } from '@/components/atoms/Icon';
import styles from './index.module.scss';

export type TextInputTypes =
  | 'text'
  | 'email'
  | 'password'
  | 'number'
  | 'date'
  | 'datetime-local'
  | 'time'
  | 'url';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AntdInputWithRefProps = AntdInputProps & React.RefAttributes<any>;

export interface InputProps extends AntdInputWithRefProps {
  label?: string;
  value?: string;
  invalid?: boolean;
  iconId?: string;
  type?: TextInputTypes;
  onClear?: () => void;
}

export function Input({
  label,
  invalid,
  value,
  iconId,
  className,
  type = 'text',
  onChange,
  onBlur,
  onKeyUp,
  onClear,
  ...props
}: InputProps): JSX.Element {
  const showClear = useMemo(() => (value?.length && onClear) || undefined, [value, onClear]);

  return (
    <span className={classNames(className)}>
      <AntdInput
        aria-label={label}
        className={classNames(
          styles.baseInput,
          styles.inputElement,
          invalid && styles.invalid,
          iconId && styles.icon
        )}
        placeholder={label}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        type={type}
        {...props}
      />
      {iconId && <Icon id={iconId} className={styles.inputIcon} />}
      {showClear && (
        <button className="clear" type="button" onClick={onClear} name="clear">
          <Icon id="icon_cross_thin" width={10} />
          Clear
        </button>
      )}
    </span>
  );
}
